import { render, staticRenderFns } from "./PatientRecall.vue?vue&type=template&id=431a494b&scoped=true"
import script from "./PatientRecall.vue?vue&type=script&lang=ts"
export * from "./PatientRecall.vue?vue&type=script&lang=ts"
import style0 from "./PatientRecall.vue?vue&type=style&index=0&id=431a494b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a494b",
  null
  
)

export default component.exports